<div class="ipm-aadhar">
    <mat-accordion class="example-headers-align" [className]="'ipm-custom-accordion'">
        <ng-container *ngFor="let accordionData of accordionArray; let i = index">
            <ng-container *ngIf="!accordionData?.isHide">
                <mat-expansion-panel (opened)="togglePanel(i, true)"
                (closed)="togglePanel(i, false)" [disabled]="!currentUserData.mobile || (currentUserData.mobile  && !currentUserData.mobile.isVerified) || accordionData?.isVerified"
                [expanded]="accordionData?.isVerified || (currentUserData.mobile  && currentUserData.mobile.isVerified)">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="text-area">
                            <span class="ipm-id-heading">
                                <ng-container *ngIf="accordionData.type === 'aadhar' && ((!currentUserData?.aadhaarVerification?.guardianRequired && currentUserData?.aadhaarVerification?.verified) || 
                                (currentUserData?.aadhaarVerification?.guardianVerified && currentUserData?.aadhaarVerification?.guardianRequired && currentUserData?.aadhaarVerification?.verified))">
                                    <img src="./assets/imgs/check-icon.png" alt="check-icon" height="15px" width="15px">
                                </ng-container>
                                {{ accordionData?.header?.mainHeading }}
                            </span>
                            <span class="ipm-id-subtext" *ngIf="!accordionData?.isVerified">
                                {{  !currentUserData.mobile|| (currentUserData.mobile  && !currentUserData.mobile.isVerified) ? "Verify your mobile no. first to continue." : accordionData?.header?.subHeading}}
                            </span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="accordionData.type === 'aadhar'">
                    <div class="ipm-aadhar-details">
                        <ng-container *ngIf="!currentUserData?.aadhaarVerification || (currentUserData?.aadhaarVerification && (!currentUserData?.aadhaarVerification.verified || (currentUserData?.aadhaarVerification?.guardianRequired &&  !currentUserData?.aadhaarVerification?.guardianVerified))) else verifiredTemplate">
                             <div class="row">
                                <div class="col-12">
                                    <div class="form-group custom-form-group ipm-aadhar-radio-btn mb-0">
                                        <div class="d-flex custom-radio-button flex-colum">
                                            <mat-radio-group
                                                aria-labelledby="ageConfirmation"
                                                class="example-radio-group"
                                                [(ngModel)]="aadharIndentification"
                                                [disabled]="isLoadingAddahar ||  (currentUserData.aadhaarVerification?.guardianRequired && currentUserData.aadhaarVerification.verified)"
                                                (change)="onAadharIdentificationChange($event)">
                                                <mat-radio-button class="example-radio-button me-5 ipm-radio-button" value="adult">
                                                    I’m an Adult (18 years or older)
                                                </mat-radio-button>
                                                <mat-radio-button class="example-radio-button ipm-radio-button" value="minor">
                                                    I’m a Minor (Below 18 years)
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                </div>
                                <ng-container *ngIf="aadharIndentification === 'adult' else minorTemplate">
                                    <div class="col-12 col-lg-4 mt-2 mb-4">
                                        <button class="btn ipm-submit-btn m-0" type="submit" (click)="openIdentityWarningBanner('aadhar')" [disabled]="isLoadingAddahar">Verify via DigiLocker</button>
                                    </div>
                                    <div class="col-12">
                                        <p class="ipm-message" *ngIf="!isLoadingAddahar">
                                            <span class="info-icon">
                                                <span>!</span>
                                            </span> We’ll redirect you to DigiLocker to authorize your aadhar verification. No manual input needed.
                                        </p>
                                        <p class="ipm-message" *ngIf="isLoadingAddahar" >
                                            <span class="loader-icon">
                                                <ipm-loading-spinner [isShowBeatLoading]="true" [type]="'general'"></ipm-loading-spinner>
                                            </span>
                                             Verifying your information… This may take a few seconds. Please don’t close this window.
                                        </p>
                                    </div>
                                </ng-container>
                                <ng-template #minorTemplate>
                                    <div class="common-card-aadhar" *ngIf="!currentUserData?.aadhaarVerification?.verified; else minorVerifiedTemplate">
                                        <div class="col-12">
                                            <div class="ipm-header">
                                                <span class="ipm-id-heading">Step 1: Minor Aadhaar Verification</span>
                                            </div>
                                            
                                            <div class="col-12 col-lg-4 mt-2 mb-4">
                                                <button class="btn ipm-submit-btn m-0" type="submit" (click)="openIdentityWarningBanner('aadhar')" [disabled]="isLoadingAddahar || currentUserData.aadhaarVerification?.guardianRequired && currentUserData.aadhaarVerification.verified">Verify via DigiLocker</button>
                                            </div>
                                            <div class="col-12">
                                                <p class="ipm-message" *ngIf="!isLoadingAddahar">
                                                    <span class="info-icon">
                                                        <span>!</span>
                                                    </span> We’ll redirect you to DigiLocker to authorize your Aadhaar verification. This will verify the minor’s address and supporting details.
                                                </p>
                                                <p class="ipm-message" *ngIf="isLoadingAddahar" >
                                                    <span class="loader-icon">
                                                        <ipm-loading-spinner [isShowBeatLoading]="true" [type]="'general'"></ipm-loading-spinner>
                                                    </span>
                                                    Verifying your information… This may take a few seconds. Please don’t close this window.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="common-card-aadhar">
                                        <div class="col-12">
                                            <div class="ipm-header">
                                                <span class="ipm-id-heading">Step 2: Guardian Aadhaar Verification</span>
                                                <ng-container *ngIf="!currentUserData?.aadhaarVerification?.verified">
                                                      <p class="sub-heading">Verify the minor's Aadhar first to continue</p>
                                                </ng-container>
                                                <ng-container *ngIf="currentUserData?.aadhaarVerification?.verified && !currentUserData?.aadhaarVerification?.guardianVerified">
                                                    <p class="sub-heading">A parent/guardian must verify their identity to complete this process.</p>
                                                </ng-container>
                                            </div>
                                            <div class="col-12 col-lg-4 mt-2 mb-3">
                                               
                                                <button class="btn ipm-submit-btn m-0" type="submit" (click)="openIdentityWarningBanner('Gaadhar')" [disabled]="isLoadingAddahar || aadharIndentification === 'minor' && (currentUserData.aadhaarVerification && !currentUserData.aadhaarVerification?.verified)">Verify via DigiLocker</button>
                                            </div>
                                            <div class="col-12">
                                                 <p class="ipm-message" *ngIf="!isLoadingAddahar">
                                                    <span class="info-icon">
                                                        <span>!</span>
                                                    </span> 
                                                    We’ll redirect you to DigiLocker to authorize your Aadhaar verification. This will verify the Gaurdian’s details.
                                                </p>
                                                <p class="ipm-message" *ngIf="isLoadingAddahar && currentUserData?.aadhaarVerification?.verified" >
                                                    <span class="loader-icon">
                                                        <ipm-loading-spinner [isShowBeatLoading]="true" [type]="'general'"></ipm-loading-spinner>
                                                    </span>
                                                    Verifying your information… This may take a few seconds. Please don’t close this window.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template #minorVerifiedTemplate>
                                    <div class=" common-card-aadhar ipm-minor-template">
                                        <div class="col-12">
                                            <div class="ipm-header">
                                                <span class="ipm-id-heading">Step 1: Minor Aadhaar Verification</span>
                                            </div>
                                            <div class="ipm-minor-details">
                                                <div class="user-details-section">
                                                    <span class="heading">Name:</span>
                                                    <span class="value">{{currentUserData.aadhaarVerification?.name}}</span>
                                                </div>
                                                <div class="user-details-section">
                                                    <span class="heading">Age:</span>
                                                    <span class="value">{{(currentUserData.aadhaarVerification?.dob | getAge )}} years</span>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <p class="ipm-message-verified">
                                                    <span class="check-icon">
                                                       <img src="./assets/imgs/check-icon.png" alt="check-icon" height="15px" width="15px">
                                                    </span> Minor’s detail has been successfully verified via DigiLocker.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </ng-container>
                        <ng-template #verifiredTemplate>
                              <div class=" common-card-aadhar ipm-minor-template">
                                        <div class="col-12">
                                            <div class="ipm-header">
                                                <ng-conatiner *ngIf="!currentUserData.aadhaarVerification?.guardianRequired">
                                                    <span class="ipm-id-heading">Aadhaar Verification</span>
                                                </ng-conatiner>
                                                <ng-conatiner *ngIf="currentUserData.aadhaarVerification?.guardianRequired">
                                                   <span class="ipm-id-heading">Step 1: Minor Aadhaar Verification</span>
                                                </ng-conatiner>
                                            </div>
                                            <div class="ipm-minor-details">
                                                <div class="user-details-section">
                                                    <span class="heading">Name:</span>
                                                    <span class="value">{{currentUserData.aadhaarVerification?.name}}</span>
                                                </div>
                                                <div class="user-details-section">
                                                    <span class="heading">Age:</span>
                                                    <span class="value">{{currentUserData.aadhaarVerification?.dob | getAge}} years</span>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <p class="ipm-message-verified">
                                                    <span class="check-icon">
                                                       <img src="./assets/imgs/check-icon.png" alt="check-icon" height="15px" width="15px">
                                                    </span> Aadhaar Card detail has been successfully verified via DigiLocker.
                                                </p>
                                            </div>
                                        </div>
                                </div>
                                <div class=" common-card-aadhar ipm-minor-template" *ngIf="currentUserData.aadhaarVerification?.guardianRequired">
                                    <div class="col-12">
                                        <div class="ipm-header">
                                                <span class="ipm-id-heading">Step 2: Guardian Aadhaar Verification </span>
                                        </div>
                                        <div class="ipm-minor-details">
                                            <div class="user-details-section">
                                                <span class="heading">Name:</span>
                                                <span class="value">{{currentUserData.aadhaarVerification?.guardian?.name}}</span>
                                            </div>
                                            <div class="user-details-section">
                                                <span class="heading">Age:</span>
                                                <span class="value">{{currentUserData.aadhaarVerification?.guardian?.dob | getAge}} years</span>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <p class="ipm-message-verified">
                                                <span class="check-icon">
                                                    <img src="./assets/imgs/check-icon.png" alt="check-icon" height="15px" width="15px">
                                                </span> Guardian detail has been successfully verified via DigiLocker.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="common-card-aadhar">
                                    <div class="col-12">
                                         <p class="ipm-message">
                                            <span class="info-icon">
                                                <span>!</span>
                                            </span> 
                                            These details are now linked to your account and cannot be modified. For any issues, contact support.
                                        </p>
                                    </div>
                                </div>
                        </ng-template>
                       
                    </div>
                </ng-container>
                <ng-container *ngIf="accordionData.type === 'passport'">
                    <div class="ipm-passport-details-form">
                        <ng-container *ngIf="accordionData.isOpened">
                             <form class="custom-form " [formGroup]='passportForm'>
                            <div class="row">
                                <div class="col-md-7">
                                    <!-- <ipm-mobile-verify [form]="passportForm" [currentUserData]="currentUserData" [isShowActionButton]="false"></ipm-mobile-verify> -->
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7 me-md-3">
                                    <div class="form-group custom-form-group">
                                        <input type="text" class="form-control" id="passportNumber" name="passportNumber"
                                            formControlName="passportNumber"
                                            [class.ipm-error-border]="passportForm.controls['passportNumber'].invalid && passportForm.controls['passportNumber'].touched"
                                            required>
                                        <span class="floating-label" aria-label="Your Passport Number">Passport Number<sup>*</sup></span>
                                        <div class="ipm-error-icon ipm-error-with-label"
                                            *ngIf="passportForm.controls['passportNumber'].invalid && passportForm.controls['passportNumber'].touched">
                                            <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                                        </div>
                                        <div class="help-block error-message"
                                            *ngIf="passportForm.controls['passportNumber'].invalid && passportForm.controls['passportNumber'].touched">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                            {{formService.getErrorMessage(passportForm.controls['passportNumber'])}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group custom-form-group ipm-icon-more">
                                        <input type="text" class="form-control" id="passportdob" name="passportdob"
                                            formControlName="passportdob" autocomplete="off" maxlength="20"
                                            [class.error-border-color]="passportForm.controls['passportdob'].invalid && passportForm.controls['passportdob'].touched"
                                            [matDatepicker]="datePickerDOB" (click)="datePickerDOB.open()" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="datePickerDOB"></mat-datepicker-toggle>
                                        <span class="floating-label">Date of Birth</span>
                                        <div class="ipm-error-icon ipm-error-with-label error-dropdown"
                                            *ngIf="passportForm.controls['passportdob'].invalid && passportForm.controls['passportdob'].touched">
                                            <img priority src="./assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                                        </div>
                                        <mat-datepicker #datePickerDOB>
                                        </mat-datepicker>
                                        <div class="help-block error-message"
                                            *ngIf="passportForm.controls['passportdob'].invalid && passportForm.controls['passportdob'].touched">
                                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                            {{formService.getErrorMessage(passportForm.controls['passportdob'])}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-lg-4 mb-3">
                                    <button class="btn ipm-submit-btn m-0" type="submit" (click)="openIdentityWarningBanner('passport')"
                                        [disabled]="!passportForm.valid">Verify Passport</button>
                                </div>
                                <div class="col-12">
                                    <p class="ipm-message">
                                        <span class="info-icon">
                                            <span>!</span>
                                        </span> Securely connect to the official verification service to confirm your identity.
                                    </p>
                                </div>
                            </div>
                        </form>
                        </ng-container>
                       
                    </div>
                </ng-container>
                </mat-expansion-panel>
            </ng-container>
        </ng-container>
    </mat-accordion>
</div>


<ng-template #identityWarningBannerDialog let-data>
    <div class="ipm-identity-popup-section-section">
        <div class="identity-heading-section">
            <div class="check-section">
               <span class="icon">!</span>
            </div>
            <h4>Before you Proceed!</h4>
        </div>
        <div class="ipm-pop-up-section">
            <ng-container *ngIf="data?.popupType === 'aadhar' || data?.popupType === 'Gaadhar'">
                <ng-container *ngIf="!currentUserData?.aadhaarVerification?.verified || !currentUserData.aadhaarVerification?.guardianVerified; else nonVerifiedAadhar">
                   <p> We will securely store your information, such as <strong>name</strong>, <strong>address</strong>, and supporting details obtained via DigiLocker, in our databases for KYC purposes and for generating contracts with buyers of your intellectual property.</p>

                   <p>At no point will your Aadhaar credentials or images be stored on our servers or databases.</p>
                </ng-container>
                <ng-template #nonVerifiedAadhar>
                    <p>This will not change your legal name, it only updates your permanent address.</p>
                    <ol>
                        <li>You can’t use this to switch identities.</li>
                        <li>If your name and DOB don’t match our KYC records, we can’t verify or update your address.</li>
                        <li>Verified info will be used to generate the agreements.</li>
                    </ol>
                </ng-template>
                
            </ng-container>
             <ng-container *ngIf="!currentUserData?.aadhaarVerification?.verified || !currentUserData.aadhaarVerification?.guardianVerified; else nonVerifiedOtherAadhar">
                <p><strong>You will need to link your guardian’s Aadhaar if you’re age is below 18.</strong></p>
             </ng-container>
             <ng-template #nonVerifiedOtherAadhar>
                <p *ngIf="data?.popupType === 'aadhar' ">
                    <ng-container *ngIf="aadharIndentification === 'adult'">
                        This will update your KYC records.
                    </ng-container>
                    <ng-container *ngIf="aadharIndentification !== 'adult'">
                        This will not update your Guardian’s information.
                    </ng-container>
                </p>
                <p *ngIf="data?.popupType === 'Gaadhar' ">
                    This will not update the Minor’s information.
                </p>
             </ng-template>

           
            <p *ngIf="data?.popupType === 'passport' ">Please use your guardian’s Passport if you’re age is below 18.</p>
             <div class="checkout-flow">
                <mat-checkbox [(ngModel)]="isAccepted" required>
                    I have read and agree to the <a href="javascript:void(0)" role="button" href="/terms-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
                   above. I confirm that I’m verifying my own identity and provide my full consent to proceed with the verification.
                </mat-checkbox>
            </div>
        </div>
        <div class="d-flex ipm-action-btn-section">
            <button class="btn ipm-close-btn-identity ipm-common-btn" (click)="closeDialogBox('cancel')">
                Cancel
            </button>
            <button class="btn ipm-common-btn" (click)="closeDialogBox('verify')" [disabled]="!isAccepted">
                {{data?.popupType === 'aadhar' ||  data?.popupType === 'Gaadhar' ? 'Continue with DigiLocker' : 'Verify my Passport'}}
            </button>
        </div>
    </div>
</ng-template>
